/**
 * SparkleCluster — group of tiny sparkles with staggered twinkle animations
 */

import { motion } from 'framer-motion';
import { kidPalette } from '../../styles/kidPalette';

interface SparkleClusterProps {
  count?: number;
  spread?: number;
  className?: string;
}

const sparkleColors = [kidPalette.dandelion, kidPalette.sky, kidPalette.violet, kidPalette.berry, kidPalette.ocean];

export default function SparkleCluster({
  count = 4,
  spread = 40,
  className = '',
}: SparkleClusterProps) {
  // Deterministic positions based on index
  const sparkles = Array.from({ length: count }, (_, i) => ({
    x: ((i * 37 + 13) % spread) - spread / 2,
    y: ((i * 23 + 7) % spread) - spread / 2,
    size: 6 + (i % 3) * 3,
    color: sparkleColors[i % sparkleColors.length],
    delay: i * 0.4,
  }));

  return (
    <div className={`pointer-events-none relative ${className}`} style={{ width: spread, height: spread }}>
      {sparkles.map((s, i) => (
        <motion.svg
          key={i}
          width={s.size}
          height={s.size}
          viewBox="0 0 12 12"
          fill="none"
          className="absolute"
          style={{ left: `calc(50% + ${s.x}px)`, top: `calc(50% + ${s.y}px)` }}
          animate={{
            scale: [0, 1, 0],
            opacity: [0, 1, 0],
          }}
          transition={{
            repeat: Infinity,
            duration: 1.8,
            delay: s.delay,
            ease: 'easeInOut',
          }}
        >
          <path
            d="M6 0L7 4.5L12 6L7 7.5L6 12L5 7.5L0 6L5 4.5Z"
            fill={s.color}
          />
        </motion.svg>
      ))}
    </div>
  );
}
